import helpers from '../helpers.js';
import BCVField from './validatable_field/validatable_field.js';
import Absence from './validators/absence/absence.js';
import Acceptance from './validators/acceptance/acceptance.js';
import Confirmation from './validators/confirmation/confirmation.js';
import Datetime from './validators/datetime/datetime.js';
import Exclusion from './validators/exclusion/exclusion.js';
import Format from './validators/format/format.js';
import Inclusion from './validators/inclusion/inclusion.js';
import Integer from './validators/integer/integer.js';
import Length from './validators/length/length.js';
import Numericality from './validators/numericality/numericality.js';
import Required from './validators/required/required.js';
import RequiredIf from './validators/required/required-if.js';

/**
 * @ngdoc service
 * @name BaseClass.BCValidatable
 * @description
 * Model extension for validation
 */
export default angular.module('BaseClass.validatable',[
    BCVField,Absence,Acceptance,Confirmation,Datetime,Exclusion,Format,Inclusion,Integer,Length,Numericality,Required,RequiredIf
])
    .factory('BCValidatable', function(BCVField,
        absence, acceptance, confirmation, datetime, exclusion, format, inclusion, integer, length, numericality, required, requiredIf) {
    /**
     * Mixin that adds model validation
     */
        function Validatable() {
            var validations = {};

            helpers.privateVariable(validations, 'add', function(validationSpec) {
                _.each(validationSpec, addField);
            });

            helpers.privateVariable(validations, 'validate', function(instance, fieldName) {
                var toValidate = getFieldsToValidate(fieldName);
                _.each(toValidate, _.curry(validateField)(instance));
                return instance.$errors.countFor(fieldName) === 0;
            });

            function validateField(instance, validation) {
                if (validation.validate(instance) === false)
                    instance.$errors.add(validation.field, validation.message);
                else
                    instance.$errors.clear(validation.field, validation.message);
            }

            function getFieldsToValidate(fieldName) {
                if (fieldName) return validations[fieldName] || [];

                return _.chain(validations)
                    .map(function(validations) {
                        return validations;
                    }).flatten().value();
            }

            function addField(validationSet, fieldName) {
                if (validations[fieldName])
                    validations[fieldName].addValidators(validationSet);
                else
                    validations[fieldName] = new BCVField(fieldName, validationSet);
            }

            this.validations = validations;
            /**
         * @ngdoc method
         * @name BaseClass.BCValidatable#validates
         * @methodOf BaseClass.BCValidatable
         * @static
         * @description
         * Add validation rules to model
         *
         * @param {Object} validationSet Validation rules, keyed by attribute name
         *
         * @example
         * <pre>
         * Model.validates({
         *     birthday: {
         *         required: true, //simple rules can be enabled
         *         format: {
         *             regex: {
         *                 regex: /^\d{2}-\d{2}-\d{y}$/,
         *                 message: 'must be a date formatted as DD-MM-YYYY'
         *             },
         *         }
         *     },
         *     name: {
         *         inclusion: {
         *             in: ['Chris','Joost','Rick','Mart','Max'],
         *             message: 'sorry, you\'re not awesome enough'
         *         },
         *         exclusion: {
         *             from: ['Jeroen'],
         *             message: 'we don\'t take kindly to to folks that drive \'em fancy cars'
         *         },
         *     },
         *     otherRules: {
         *          format: {
         *              boolean: true,
         *              email: true
         *          },
         *          integer: {
         *              message: 'even simple true/false rules can have custom messages'
         *          },
         *          numericality: true
         *          length: { // string length
         *              min: 1,
         *              max: 5,
         *              is: 3,
         *          },
         *          absence: true,
         *          customRule: {
         *              message: 'This custom validator returned invalid',
         *              optionA: 12,
         *              validator: function(value, instance, field) {
         *                  // Returning false == invalid
         *                  return value >= this.optionA;
         *              }
         *          }
         *     }
         * });
         * </pre>
         */
            this.validates = validations.add;

            helpers.privateVariable(this,'__validate', function(fieldName) {
                return this.constructor.validations.validate(this, fieldName);
            });

            /**
         * @ngdoc method
         * @name BaseClass.BCValidatable#$valid
         * @methodOf BaseClass.BCValidatable
         * @description
         * Check if instance is valid
         * @returns {Boolean} True if model is valid
         */
            Object.defineProperty(this, '__$valid', {
                get: function() { return this.constructor.validations.validate(this); }
            });

            /**
         * @ngdoc method
         * @name BaseClass.BCValidatable#$invalid
         * @methodOf BaseClass.BCValidatable
         * @description
         * Check if instance is invalid
         * @returns {Boolean} True if model is invalid
         */
            Object.defineProperty(this, '__$invalid', {
                get: function() { return !this.constructor.validations.validate(this); }
            });
        }

        return Validatable;
    }).name;
